<div class="containerTest">
    <div class="text-center">
        <h1 *ngIf="!agencyID">All Enrolled Users</h1>
        <h1 *ngIf="agencyID">Users enrolled under Agency: {{ agency?.agencyName }}</h1>
    </div>
    <hr>
    <div class="card">
        <div class="card-body" style="overflow-x:auto;">

            <!-- Header -->
            <article class="table-header">
                <!-- Toolbar -->
                <div class="toolbar dt-buttons mb-4">
                    <!-- Upload RW Users -->
                    <button *ngIf="agencyID && agency" type="button" class="dt-button" (click)="uploadUsers(agency, 'RentWise')">Upload RW Users</button>

                    <!-- Upload FHE Users -->
                    <button *ngIf="!(agencyID || agency)" type="button" class="dt-button" (click)="uploadUsers(null, 'Fair Housing Education')">Upload FHE Users</button>

                    <!-- Copy GeoJSON Link -->
                    <button type="button" class="dt-button" (click)="copyGeoJsonLink()">
                        <span>Copy GeoJSON Link</span>
                        <img class="arcgis-logo ml-2" src="/assets/arcgis-globe-icon.png" height="23">
                    </button>

                    <!-- Copy GeoRSS Link -->
                    <button type="button" class="dt-button" (click)="copyGeoRssLink()">
                      <span>Copy GeoRSS Link</span>
                      <mdb-icon class="rss-icon ml-1 text-danger" fas icon="rss-square"></mdb-icon>
                    </button>
                </div>
            </article>

            <!-- Table -->
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
                <thead>
                    <tr>
                        <th>Status</th>
                        <th>First Name</th>
                        <th>Middle Initial</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Registered</th>
                        <th>Last Active</th>
                        <th>RW Progress</th>
                        <th>RW Completion Date</th>
                        <th>RW Completion In Person</th>
                        <th>HPE Progress</th>
                        <th>HPE Completion Date</th>
                        <th>Age Under 18</th>
                        <th>Primary Role</th>
                        <th>Company Name</th>
                        <th>Date of Birth</th>
                        <th>Race</th>
                        <th>Ethnicity</th>
                        <th>Are They Disabled?</th>
                        <th>Number of Children</th>
                        <th>Marital Status</th>
                        <th style="min-width:200px">Family Status</th>
                        <th>Education</th>
                        <th>Annual Income</th>
                        <th>Source of Income</th>
                        <th>Street Address 1</th>
                        <th>Street Address 2</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Zip Code</th>
                        <th>County</th>
                        <th>Latitude</th>
                        <th>Longitude</th>
                        <th>Primary Residence</th>
                        <th>Living Situation</th>
                        <th style="min-width:200px">Agency Name</th>
                        <th>Agency Street Address 1</th>
                        <th>Agency Street Address 2</th>
                        <th>Agency City</th>
                        <th>Agency State</th>
                        <th>Agency Zip Code</th>
                        <th>Agency County</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of users; index as i">
                        <td>{{ user.banned ? 'Banned' : 'Active' }}</td>
                        <td>{{ user.firstName }}</td>
                        <td>{{ user.middleInitial }}</td>
                        <td>{{ user.lastName }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.phone }}</td>
                        <td [attr.data-sort]="sortDate(user.registered)">
                          <span *ngIf="user.registered" class="text-nowrap">{{ user.registered | date:'mediumDate' }}</span>
                          <span *ngIf="!user.registered">N/A</span>
                        </td>
                        <td [attr.data-sort]="sortDate(user.lastActive)">
                          <ng-container *ngIf="user.lastActive">
                            <span class="text-nowrap">{{ user.lastActive | date:'mediumDate' }}</span>,
                            <span class="text-nowrap">{{ user.lastActive | date:'shortTime' }}</span>
                          </ng-container>
                          <ng-container *ngIf="!user.lastActive">N/A</ng-container>
                        </td>
                        <td>{{ (user.rentwiseProgress | percentage) || 'N/A' }}</td>
                        <td [attr.data-sort]="sortDate(user.rentwiseCompletionDate)">{{ (user.rentwiseCompletionDate | date) || 'N/A' }}</td>
                        <td>{{ user.rentwiseCompletionInPerson | boolean:'Yes':'No' }} </td>
                        <td>{{ (user.fheProgress | percentage) || 'N/A' }}</td>
                        <td [attr.data-sort]="sortDate(user.fheCompletionDate)">{{ (user.fheCompletionDate | date) || 'N/A' }}</td>
                        <td>{{ user.ageUnder18 | boolean:'Yes':'No' }}</td>
                        <td>
                          <span *ngIf="user.primaryRole === 'Other' && user.primaryRoleOther">{{ user.primaryRole }} – {{ user.primaryRoleOther }}</span>
                          <span *ngIf="!(user.primaryRole === 'Other' && user.primaryRoleOther)">{{ user.primaryRole || 'N/A' }}</span>
                        </td>
                        <td>
                          <span *ngIf="user.primaryRole === 'Housing Provider – Owner' || user.primaryRole === 'Housing Provider – Property Management'">{{ user.companyName || 'N/A' }}</span>
                          <span *ngIf="!(user.primaryRole === 'Housing Provider – Owner' || user.primaryRole === 'Housing Provider – Property Management')">{{ 'N/A' }}</span>
                        </td>
                        <td [attr.data-sort]="sortDate(user.dob)">{{ user.dob | date }}</td>
                        <td>{{ user.race }}</td>
                        <td>{{ user.ethnicity }}</td>
                        <td>{{ user.disabled | boolean:'Yes':'No' }}</td>
                        <td>{{ user.numberOfChildren }}</td>
                        <td>{{ user.maritalStatus }}</td>
                        <td>{{ user.familyStatus }}</td>
                        <td>{{ user.education }}</td>
                        <td>{{ user.annualIncome }}</td>
                        <td>{{ user.sourceOfIncome }}</td>
                        <td>{{ user.streetAddress }}</td>
                        <td>{{ user.secondary }}</td>
                        <td>{{ user.city }}</td>
                        <td>{{ user.state }}</td>
                        <td>{{ user.zipCode }}</td>
                        <td>{{ user.county }}</td>
                        <td>{{ user.latitude }}</td>
                        <td>{{ user.longitude }}</td>
                        <td>{{ user.primaryResidence | boolean:'Yes':'No' }}</td>
                        <td>{{ user.livingSituation }}</td>
                        <td>{{ user.agency?.agencyName }}</td>
                        <td>{{ user.agency?.streetAddress }}</td>
                        <td>{{ user.agency?.secondary }}</td>
                        <td>{{ user.agency?.city }}</td>
                        <td>{{ user.agency?.state }}</td>
                        <td>{{ user.agency?.zipCode }}</td>
                        <td>{{ user.agency?.county }}</td>
                        <td class="td-actions">
                          <div class="text-nowrap">
                            <button (click)="deleteUser(i)" class="btn-danger"><mdb-icon fas icon="trash"></mdb-icon></button>
                            <button (click)="banUser(i)" *ngIf="!user.banned" class="btn-danger">Ban</button>
                            <button (click)="unbanUser(i)" *ngIf="user.banned" class="btn-danger">Unban</button>
                          </div>
                          <div><button *ngIf="agency ? user.rentwiseCompletionInPerson : user.rentwiseCompletionInPerson || user.fheCompletionInPerson" (click)="deleteCourse(i)">Delete Course</button></div>
                          <div class="mt-2"><button (click)="loginUnder(user.email)" class="btn-warning">Log In</button></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
